export default class ApproveCommand {
    constructor() {
        this.approve = true;
    }
}